import React, { useEffect, useState } from "react";

export default function SelectMentionModal({
  isOpen,
  setIsOpen,
  content,
  setContent,
  setMentions,
  groupMembers,
  messageInputRef,
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [filteredGroupMembers, setFilteredGroupMembers] =
    useState(groupMembers);

  // Handle keyboard events
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) {
        if (e.key === "@" && e.target === document.activeElement) {
          setIsOpen(true);
        }
        return;
      }

      switch (e.key) {
        case "ArrowUp":
          e.preventDefault();
          setSelectedIndex((prev) =>
            prev > 0 ? prev - 1 : filteredGroupMembers.length - 1
          );
          break;
        case "ArrowDown":
          e.preventDefault();
          setSelectedIndex((prev) =>
            prev < filteredGroupMembers.length - 1 ? prev + 1 : 0
          );
          break;
        case "Enter":
          e.preventDefault();
          if (filteredGroupMembers[selectedIndex]) {
            setContent(
              content.slice(0, content.lastIndexOf("@")) +
                "@" +
                filteredGroupMembers[selectedIndex].name +
                " "
            );
            setMentions((m) => [
              ...m,
              {
                pos: content.lastIndexOf("@"),
                uid: filteredGroupMembers[selectedIndex].uid,
                len: filteredGroupMembers[selectedIndex].name.length + 1,
              },
            ]);
            setIsOpen(false);
            messageInputRef.current.focus();
          }
          break;
        case "Tab":
          e.preventDefault();
          if (filteredGroupMembers[selectedIndex]) {
            setContent(
              content.slice(0, content.lastIndexOf("@")) +
                "@" +
                filteredGroupMembers[selectedIndex].name +
                " "
            );
            setMentions((m) => [
              ...m,
              {
                pos: content.lastIndexOf("@"),
                uid: filteredGroupMembers[selectedIndex].uid,
                len: filteredGroupMembers[selectedIndex].name.length + 1,
              },
            ]);
            setIsOpen(false);
            messageInputRef.current.focus();
          }
          break;
        case "Escape":
          setIsOpen(false);
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, selectedIndex, filteredGroupMembers]);

  // Handle message selection
  const handleSelectMessage = (contact) => {
    setContent(
      content.slice(0, content.lastIndexOf("@")) + "@" + contact.name + " "
    );
    setMentions((m) => [
      ...m,
      {
        pos: content.lastIndexOf("@"),
        uid: contact.uid,
        len: contact.name.length + 1,
      },
    ]);

    setIsOpen(false);
    messageInputRef.current.focus();
  };

  useEffect(() => {
    const words = content.split("@");
    const mentionsGroupMembers = [
      { _id: "all", avatar: "", name: "All", uid: "-1" },
      ...groupMembers,
    ].filter((c) =>
      c.name.toLowerCase().startsWith(words[words.length - 1].toLowerCase())
    );
    setFilteredGroupMembers(mentionsGroupMembers);
  }, [content]);

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="relative">
        {isOpen && (
          <div className="absolute bottom-full w-full mb-2 bg-white border rounded-lg shadow-lg z-20">
            <div className="p-2 text-sm text-muted-foreground border-b">
              Nhấn Enter hoặc Click chuột để chọn, nhấn phím ↑ ↓ để điều hướng
            </div>
            <div className="max-h-[300px] overflow-y-auto">
              {filteredGroupMembers.map((contact, index) => (
                <div
                  key={contact._id}
                  className={`flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-200 ${
                    index === selectedIndex ? "bg-gray-200" : ""
                  }`}
                  onClick={() => handleSelectMessage(contact)}
                >
                  <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center">
                    {contact._id === "all" ? (
                      <span className="text-2xl">@</span>
                    ) : (
                      <img
                        src={contact.avatar}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    )}
                  </div>
                  <div className="flex-1 truncate text-sm">
                    {contact._id === "all" ? (
                      <>
                        Báo cho cả nhóm{" "}
                        <span className="text-blue-500">@All</span>
                      </>
                    ) : (
                      contact.name
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
